import { createContext } from 'react';
import { ICreateVideoStudio } from 'types';

export type TTypeOfCreateVideoStudioModalWindow =
	| null
	| 'toConfirmFieldsClearing'
	| 'toConfirmSubmit'
	| 'success'
	| 'error';

export interface ICreateVideoStudioState {
	name: string;
	dataForSubmit: ICreateVideoStudio | null;
	typeOfModalWindow: TTypeOfCreateVideoStudioModalWindow;
}

export const createVideoStudioInitialState: ICreateVideoStudioState = {
	name: '',
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateVideoStudioContext extends ICreateVideoStudioState {
	changeName(value: string): void;
	setDataForSubmit(value: ICreateVideoStudio | null): void;
	changeTypeOfModalWindow(value: TTypeOfCreateVideoStudioModalWindow): void;
	resetFields(): void;
}

export const CreateVideoStudioContext = createContext<ICreateVideoStudioContext>({
	changeName: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createVideoStudioInitialState,
});
